var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { IconWrapper } from ".";
export const CityIcon = React.forwardRef((_a, ref) => {
    var { color = "primary" } = _a, otherProps = __rest(_a, ["color"]);
    return (React.createElement(IconWrapper, Object.assign({ ref: ref, width: 24, height: 24, color: color }, otherProps),
        React.createElement("path", { d: "M4 4C4 3.44772 4.44772 3 5 3H11C11.5523 3 12 3.44772 12 4C12 4.55228 11.5523 5 11 5H5C4.44772 5 4 4.55228 4 4Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 6C2.44772 6 2 6.44772 2 7C2 7.55228 2.44772 8 3 8L3 22H13V8C13.5523 8 14 7.55228 14 7C14 6.44772 13.5523 6 13 6H3ZM11 10H9V12H11V10ZM5 10H7V12H5V10ZM11 14H9V16H11V14ZM5 14H7V16H5V14ZM11 18H9V20H11V18ZM5 18H7V20H5V18Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 9C15 8.44772 15.4477 8 16 8H20C20.5523 8 21 8.44772 21 9V22H15V9ZM17 10H19V12H17V10ZM19 14H17V16H19V14ZM17 18H19V20H17V18Z" })));
});
//# sourceMappingURL=City.js.map